export type FlowisleUiIconName = "workspace" | "history" | "delivery" | "plus" | "panel";

export function FlowisleUiIcon({ name, className = "" }: { name: FlowisleUiIconName; className?: string }) {
  const common = { fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };
  return (
    <svg className={["flowisle-ui-icon", className].filter(Boolean).join(" ")} viewBox="0 0 24 24" aria-hidden="true">
      {name === "workspace" ? <><path {...common} d="M4.5 5.5h6v5.8h-6zM13.5 5.5h6v3.1h-6zM13.5 11.6h6v6.9h-6zM4.5 14.3h6v4.2h-6z" /></>
      : name === "history" ? <><path {...common} d="M5.2 7.3A8 8 0 1 1 4 12" /><path {...common} d="M4.8 3.8v4.1h4.1M12 7.7v4.6l3 1.7" /></>
      : name === "delivery" ? <><path {...common} d="M5 14.5v4h14v-4M12 4.5v10M8.3 11l3.7 3.7 3.7-3.7" /></>
      : name === "plus" ? <path {...common} d="M12 5v14M5 12h14" />
      : <><rect {...common} x="4" y="4.5" width="16" height="15" rx="2.5" /><path {...common} d="M9 4.5v15M13 9h4M13 12h4" /></>}
    </svg>
  );
}

export function FlowisleThinkingGlyph() {
  return (
    <svg className="flowisle-thinking-glyph" viewBox="0 0 28 28" aria-hidden="true">
      <path d="M4 16.2c3.2-5.9 7.2-8.8 12-8.8 3.4 0 6 1.2 8 3.6" />
      <path d="M5.5 20.3c3.1-3.8 6.2-5.7 9.4-5.7 2.7 0 5.1.9 7.2 2.8" />
      <path d="M10.1 23c1.7-1.6 3.3-2.4 4.9-2.4 1.3 0 2.5.4 3.6 1.2" />
      <circle cx="20.8" cy="6.2" r="2.2" />
    </svg>
  );
}
